import React from 'react';
import Form from 'react-bootstrap5/Form';

import { useTableContext } from './TableContext';
import Actions from './Actions';

export default function Checkbox() {
  const { state, dispatch } = useTableContext();

  const checkboxRef = React.useRef();

  React.useEffect(() => {
    if (state.filteredRows.length > 0 && state.selectedRows.length > 0) {
      if (
        state.filteredRows.every((rowId) => state.selectedRows.includes(rowId) || state.disabledRows.includes(rowId))
      ) {
        checkboxRef.current.checked = true;
        checkboxRef.current.indeterminate = false;
      } else {
        checkboxRef.current.checked = false;
        checkboxRef.current.indeterminate = true;
      }
    } else {
      checkboxRef.current.checked = false;
      checkboxRef.current.indeterminate = false;
    }
  }, [state.filteredRows, state.selectedRows]);

  return (
    <Form.Check
      ref={checkboxRef}
      onChange={(e) => Actions.allRowsToggle(dispatch, e.currentTarget.checked)}
      disabled={!state.filteredRows.length}
    />
  );
}
